
<div class="header-toolbar">
  <h1>Registre des actions</h1>
</div>

<div class="settings">
  <a class="item" routerLink="/shares-ledger/entities">
    <t-icon name="folder"></t-icon>
    <div class="text">Entités</div>
  </a>

  <a class="item" routerLink="/shares-ledger/verify">
    <t-icon name="seal_check"></t-icon>
    <div class="text">Vérifier un registre</div>
  </a>

  <a class="item" routerLink="/shares-ledger/client-accounts">
    <t-icon name="folder_shared"></t-icon>
    <div class="text">Comptes clients</div>
  </a>

  <a class="item" routerLink="/shares-ledger/client-users">
    <t-icon name="people"></t-icon>
    <div class="text">Utilisateurs clients</div>
  </a>
</div>